import React from 'react'

import ContentDiv from './ContentDiv'
import AirportTransferBookOnline from '@common/cards/AirportTransferBookOnline';
import Image from 'next/image';
function AirportTransfers() {
    return (
        <div>
            <div className='bg-secondary py-9'>
                <div className='font-light text-center text-xl sm:text-2xl xl:text-4xl'>Taxis Birmingham Airport <b>Transfers</b></div>
                <div className='font-light text-center text-3xl'>Transfers to Birmingham Airport (BHX) – anytime, day or night</div>
            </div>
            <div className='paddingClass my-10'>
                <div className="flex flex-col items-start justify-between gap-5 lg:flex-row lg:gap-20">
                    <div className="relative w-full h-72">
                        <Image
                            layout="fill"
                            alt="Birmingham airport picture"
                            src="/assets/images/Birmingham-Airport-Transfers.jpeg"
                        />
                    </div>
                    <AirportTransferBookOnline />
                </div>
                <ContentDiv />
            </div>
        </div>
    )
}

export default AirportTransfers